<template>
  <tr 
    class="NetlifyIdentityUserTableLine d-flex align-items-center py-2 pl-2 pr-5 mb-2"
    @click="handleEdit">
    <td 
      scope="row"
      class="py-1 colStatus">
      <div 
        :style="{ 'backgroundColor': ( user.user_metadata.disabled ? 'red' : 'green') }"
        class="NetlifyIdentityUserTableLine__status mx-auto"></div>
    </td>
    <td 
      scope="row"
      class="colName py-1 flex-grow-1">
      <strong>{{ user.user_metadata.full_name }} ({{ user.email }})</strong>
    </td>
    <td 
      scope="row"
      class="colRole py-1">
      {{ user.app_metadata.roles ? user.app_metadata.roles[0] : '' }}
    </td>
    <td 
      scope="row"
      class="d-flex justify-content-end colControls">
      <b-button
        class="mr-3"
        @click.stop="handleDelete"
        variant="light">
        Delete
      </b-button>
      <b-button
        variant="light">
        Edit
      </b-button>
    </td>
  </tr>
</template>

<script>

import { deleteUserById } from 'service/netlifyIdentity'

export default {
  name: 'NetlifyIdentityUserTableLine',
  props: {
    user: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods: {
    handleDelete() {
      this.$bvModal.msgBoxConfirm(
        'Bevestig het verwijderen van de gebruiker.', {
          okVariant: 'danger',
          okTitle: 'Bevestigen',
          cancelTitle: 'Annuleren'
        })
        .then(confirmed => {
          if (confirmed) {
            
            deleteUserById({ id: this.user.id })
              .then(() => {
                this.$emit('deleted', { id: this.user.id })
                this.$emit('refresh') // TODO: Make use of delete event...
              })
          }
        })
    },
    handleEdit() {
      this.$emit('edit', { id: this.user.id })
    }
  }
}
</script>

<style lang="scss">
.NetlifyIdentityUserTableLine {
  width: 100%;
  background: white;
  border: 1px solid #DFE2E5;
  border-radius: 4px;
  color: #7F8FA4;
  line-height: 1;
  transition: all 0.15s;
  user-select: none;
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 15px 0 rgba(158, 169, 184, 0.7);
    transform: scale(1);
  }

  &__status {
    // background: #F5A623;
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
  strong {
    font-weight: 600;
    color: #354052;
  }

  .btn {
    color: #7F8FA4;

    &:hover, &:active {
      color: darken(#7F8FA4, 10%)
    }
  }
}
</style>
